.statusPillLabel {
    font-size: var(--status-pill-label-font-size);
    font-weight: var(--status-pill-label-font-weight);
}
